import {LOADING_SUCCESS} from "../actions/types";
import initialState from './initialState';

export default (prevState = initialState.loading, action) => {
    switch (action.type) {

        case LOADING_SUCCESS:
            return action.payload;
        default:
            return prevState;

    }
}



// WEBPACK FOOTER //
// ./src/reducers/loadingReducer.js